import { CompanyType } from 'context/authentication/Company.types'
import createListViewContext, { type FilterValues } from 'global/helpers/createListViewContext'

export interface CompaniesFilterValues extends FilterValues {
  keywords: string[]
  types: CompanyType[]
}

const defaultFilters: CompaniesFilterValues = {
  keywords: [],
  types: [],
}

const { ListViewProvider, useListView } = createListViewContext(defaultFilters)

export { ListViewProvider as CompaniesViewProvider, useListView as useCompaniesView }
